







import { Vue, Component, Prop } from 'vue-property-decorator';
import PlusIcon from '../../../components/icon/PlusIcon.vue';
@Component({ components: { PlusIcon } })
export default class LessonReservationButton extends Vue {
  css_class = {
    'position-absolute': true,
    'z-10': true,
    topRight: true,
    'mt-n4': true,
    'mr-n3': true,
    'd-block': true,
    'px-3': true,
    'py-1': true,
    'w-1205rem': true,
  };
}
